<script>
//
export let pageCopy;
export let pageTitle;
let theTitle;

if (pageTitle !== null) {
    theTitle = pageTitle;

} else {
    theTitle = "";
}
//
// console.log("feature one is go");
</script>
<section>
	<div class="feature-quote">

    <div>
        <p>{@html pageCopy}</p>
        {#if theTitle !== ""}
    	    <p>{@html pageTitle}</p>
        {/if }
    </div>
</div>
</section>